import React, { useContext } from 'react';
import styled from 'styled-components';

import { useAppSelector, useAppDispatch } from '../../../../store';
import { DataElementContext } from '../../../../page-components/common/DataElementContext';
import evBus from '../../../../utils/evbus';
import { appToggleCompetitions, appSetInPageIdMatch } from '../../../../modules/bets/store/actions/app';
import { processComponentProps } from '@/page-components/utils/processComponentProps';

import './index.scss';

type InPageMatchDetails = {
  children: any;
  style?: React.CSSProperties;
  styleText: string;
  className: string;
  properties?: {
    dsType: string;
    disableInPageMatchDetails?: boolean;
  };
};

const ModuleElementDiv = styled.div<{ $styleText: string }>((props) => props.$styleText);

const InPageMatchDetails = (componentProps: InPageMatchDetails) => {
  let props = componentProps;

  const dataElementContext = useContext(DataElementContext);
  [props] = processComponentProps(props, dataElementContext);

  const showCompetitions = useAppSelector((state) => state.bets.app.showCompetitions);
  const dispatch = useAppDispatch();

  const [state, setState] = React.useState({
    showMatchDetails: false,
    mType: '',
    idSport: '',
    idCategory: '',
    idTournament: '',
    idMatch: '',
  });

  const togleCompetitions = React.useCallback(() => {
    dispatch(appToggleCompetitions());
  }, [dispatch]);

  const showMatchDetails = React.useCallback(
    (data: any, event: string) => {
      if (event === 'SHOW_MATCH_DETAILS') {
        setState((v) => ({
          ...v,
          showMatchDetails: true,
          mType: data.mType,
          idSport: data.idSport,
          idCategory: data.idCategory,
          idTournament: data.idTournament,
          idMatch: data.idMatch,
        }));
        dispatch(appSetInPageIdMatch(data.idMatch));
      }
    },
    [dispatch],
  );

  const hideMatchDetails = React.useCallback(
    (data: any, event: string) => {
      if (event === 'HIDE_MATCH_DETAILS') {
        setState((v) => ({
          ...v,
          showMatchDetails: false,
          mType: '',
          idSport: '',
          idCategory: '',
          idTournament: '',
          idMatch: '',
        }));
        dispatch(appSetInPageIdMatch());
      }
    },
    [dispatch],
  );

  React.useEffect(() => {
    evBus.on('SHOW_MATCH_DETAILS', showMatchDetails);
    evBus.on('HIDE_MATCH_DETAILS', hideMatchDetails);
    return () => {
      evBus.remove('SHOW_MATCH_DETAILS', showMatchDetails);
      evBus.remove('HIDE_MATCH_DETAILS', hideMatchDetails);
    };
  }, [showMatchDetails, hideMatchDetails]);

  const contextValue = React.useMemo(() => {
    return {
      ...state,
      showCompetitions,
      togleCompetitions,
      parentContext: dataElementContext,
    };
  }, [state, showCompetitions, togleCompetitions, dataElementContext]);

  //console.log('InPageMatchDetails[contextValue]: ', contextValue);

  return (
    <ModuleElementDiv className={props.className ?? ''} $styleText={props.styleText} style={props.style}>
      <DataElementContext.Provider value={contextValue}>{componentProps.children}</DataElementContext.Provider>
    </ModuleElementDiv>
  );
};

export default InPageMatchDetails;
